module.exports = __webpack_public_path__ + "img/notis.d0b47cb8.gif";